import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as WelcomeIlustration } from "../assets/images/welcome-ilustration.svg";
import Button from "../components/button/Button";
import Paragraph from "../components/paragraph/Paragraph";
import Steps from "../components/steps/Steps";
import { ROUTES } from "../constants/routes";
import useSubscriptionStore from "../store/subscriptionStore";
import { useCheckoutSubscription } from "../hooks/useCheckoutSubscription";
import { useCheckoutOneTime } from "../hooks/useCheckoutOneTime";
import { ONE_TIME_PLANS } from "../constants/plans";

const CreateProfileSuccessfully = () => {
  const navigate = useNavigate();
  const { subscriptionType, setSubscriptionType } = useSubscriptionStore();
  const location = useLocation();
  const {
    mutate: checkoutSubscriptionMutate,
    isLoading: isCheckoutSubscriptionLoading,
  } = useCheckoutSubscription();
  const {
    mutate: checkoutOneTimeMutate,
    isLoading: isCheckoutOneTimeLoading,
  } = useCheckoutOneTime();

  // Jednokratni planovi idu na /checkout-for-one-time-access, pretplata na /checkout-for-subscription
  const isOneTime = ONE_TIME_PLANS.some(
    (p) => p.subscriptionType === subscriptionType
  );
  const checkoutSubscription = isOneTime
    ? checkoutOneTimeMutate
    : checkoutSubscriptionMutate;
  const isCheckoutLoading = isOneTime
    ? isCheckoutOneTimeLoading
    : isCheckoutSubscriptionLoading;

  return (
    <div className="create-profile-success">
      <Steps steps={4} activeStep={4} />
      <div className="create-profile-success_page">
        <WelcomeIlustration className="hover-float" />
        <div className="create-profile-success_content">
          <div className="create-profile-success_header">
            <h1>Vaš profil je uspešno kreiran.</h1>
            <Paragraph variant="p2">
              Da biste pristupili sadržaju na platformi, potrebno je da
              odaberete plan.
            </Paragraph>
          </div>
          <div className="create-profile-success_cta">
            {subscriptionType && (
              <Button
                isLoading={isCheckoutLoading}
                label="Nastavi sa kupovinom plana"
                variant="primary"
                onClick={() => {
                  checkoutSubscription(
                    {
                      ...(isOneTime
                        ? { oneTimeAccessType: subscriptionType }
                        : { subscriptionType }),
                      successUrl: `${process.env.REACT_APP_BASE_URL}${ROUTES.checkoutSuccess}?redirectTo=${location?.pathname}`,
                      cancelUrl: window.location.href,
                    },
                    {
                      onSuccess: (variable) => {
                        // @ts-ignore
                        const { checkoutLink } = variable;

                        if (checkoutLink) {
                          window.location.href = checkoutLink;
                        }
                      },
                    }
                  );

                  setSubscriptionType({ subscriptionType: null });
                }}
              />
            )}

            <Button
              label="Odaberi plan"
              variant="primary"
              onClick={() => {
                navigate(ROUTES.subscription);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProfileSuccessfully;
